// 지점 변형은 packages/branch-src/<branchId>/ 에 있다 (#880).
// 라우트 설정은 Next 가 정적 분석하므로 여기 직접 쓴다 — 재export 를 따라가지 않는다.
export { LocaleProvider, useLocale } from "#branch-src/components/LocaleProvider/index";
